module.exports = __webpack_public_path__ + "media/images/icono_info_white-48bf7106.png";